import { matchPath } from 'react-router';
import Paths from 'AppPaths';

export const eventChanged = (pathName, state) => {
  const eventMatch = matchPath(pathName, {
    path: Paths.EventDash
  });

  return state && eventMatch && eventMatch.params.eventId !== state._id;
};

export default {
  eventChanged
};
